<template>
  <div class="basic_wrap">
    <!-- 顶部注册标题 -->
    <div class="register_header">
      <div class="big_tit">
        {{ $t('register.register') }}
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main_content">
      <!-- 蚂蚁集团logo -->
      <div class="ant_group_logo">
        <img src="../../assets/images/login/login-top.png" alt="蚂蚁集团 ANT GROUP">
      </div>

      <!-- 注册表单 -->
      <div class="register_form">
        <div class="input_group">
          <input type="text" v-model="data.mobile" :placeholder="$t('user.Username')" class="form_input">
        </div>
        <div class="input_group">
          <input type="password" v-model="data.password" :placeholder="$t('user.Password')" class="form_input">
        </div>
        <div class="input_group">
          <input type="password" v-model="data.spassword" :placeholder="$t('register.ConfirmPassword')" class="form_input">
        </div>
        <div class="input_group">
          <input type="password" v-model="data.t_mobile" :placeholder="$t('register.TransactionPassword')" class="form_input">
        </div>

        <!-- 提交按钮 -->
        <div class="submit_btn"  @click="submit">
          {{ $t('register.submit') }}
        </div>

        <!-- 登录链接 -->
        <div class="login_link">
          <router-link to="/login">{{ $t('register.AlreadyHaveAccount') }}</router-link>
        </div>

      </div>

    </div>
    <div class="login_bottom">
      <img src="../../../src/assets/images/login/login-bottom.png" alt="">
    </div>

    <!-- 底部导航栏 -->
    <FooterTab :activeType="'index'" />
  </div>
</template>

<script>
import Vue from "vue";
import {
  CountDown,
  Checkbox,
  Dialog
} from "vant";
import Fetch from "../../utils/fetch";
import FooterTab from '../../components/FooterTab.vue'
import emailregister from "../../components/emailregister.vue";
import phoneregister from "../../components/phoneregister.vue";
Vue.use(CountDown)
  .use(Checkbox)
  .use(Dialog);

export default {
  name: "Register",
  components: { emailregister, phoneregister, FooterTab },
  data() {
    return {
      time: 0,
      agreement: false,
      statement: false,
      show_kefu: false,
      msg_show: true,
      showPicker: false,
      countryIndex: 0,
      countryCode: '1',
      usertype: '',
      show_icon_type: 'index', // 添加底部导航栏当前激活状态
      data: {
        password: "",
        spassword: "",
        mobile: "",
        t_mobile: "",
        code: "",
        agent: '10000'
      },
      config: {}
    };
  },
  created() {
    this.$parent.footer("user", false);
    this.getparams();
    this.show_icon_type = 'index'; // 设置当前页面为首页状态
    // 安卓返回IMEI，苹果返回UID?
    /*BSL.PhoneID('callName');
    window.callName = this.methodName;
    // 获取手机OAID
    BSL.GetOAID('getExternalInfo');
    window.getExternalInfo = this.getExternalInfoData; */
  },
  mounted() {
    if (this.$route.query.agent) {
      localStorage.setItem('agent', this.$route.query.agent);
      this.data.agent = this.$route.query.agent;
    } else {
      if (localStorage.getItem('agent')) {
        this.data.agent = localStorage.getItem('agent');
      }
    }
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    // 优先使用App.vue中已加载的配置，减少重复请求
    if (this.$parent.app && this.$parent.app.regmode) {
      this.config = this.$parent.app;
      if (this.config.regmode == '1' || this.config.regmode == '3') {
        this.usertype = 'email';
      } else {
        this.usertype = 'phone';
      }
    } else {
      // 如果没有缓存，则请求
      Fetch('/index/webconfig', {
        type: 'web'
      }).then(res => {
        this.config = res.data;
        if (this.config.regmode == '1' || this.config.regmode == '3') {
          this.usertype = 'email';
        } else {
          this.usertype = 'phone';
        }
      })
    }
  },
  methods: {
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    changeregister() {
      this.usertype = this.usertype == 'email' ? 'phone' : 'email';
    },

    methodName(r) {
      this.data.imei = r;
    },
    getExternalInfoData(info) {
      var info = JSON.parse(info);
      console.log(info);
      if (info.code == 0) {
        this.data.oaid = info.oaid;
      }
    },
    getparams() {
      var m = this.$route.query.m;
      this.data.t_mobile = m;
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.data.mobile) {
        this.$toast(this.$t('register.phoneEmpty'));
        return;
      }

      this.is_send = true;
      Fetch("/index/register_code", {
        mobile: this.data.mobile,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t('register.sendSuccess'),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
      if (!this.data.mobile) {
        this.$toast(this.$t('register.phoneEmpty'));
        return false;
      }
      if (!this.data.password) {
        this.$toast(this.$t('register.passwordEmpty'));
        return false;
      }
      if (!this.data.spassword) {
        this.$toast(this.$t('register.ConfirmPassword') + '不能为空');
        return false;
      }

      if (this.data.password != this.data.spassword) {
        this.$toast(this.$t('user.Newpasswordandconfirmpassworddonotmatch'));
        return false;
      }

      if (!this.data.code && this.config.sms_verify) {
        this.$toast(this.$t('register.codeEmpty'));
        return false;
      }
      let data = JSON.parse(JSON.stringify(this.data));
      data.mobile = this.data.mobile;
      console.log(data);
      Fetch("/index/register", {
        ...data,
      }).then((res) => {
        console.log('注册响应:', res);
        
        // 检查注册是否成功 - 根据API返回结构判断
        if (res.code === 1 && res.data) {
          // 注册成功
          if (res.data.token) {
            localStorage.setItem('token', res.data.token);
          }
          this.$toast({
            background: "#07c160",
            message: this.$t('register.signUpSuccess'),
          });
          // 注册成功后跳转到登录页面
          setTimeout(() => {
            this.$router.replace("/login");
          }, 1500); // 延迟1.5秒跳转，让用户看到成功提示
        } else {
          // 注册失败，显示具体错误信息
          const currentLang = this.$i18n.locale || 'zh_cn';
          let errorMessage;
          
          if (res.info && res.info[currentLang]) {
            // 使用后端返回的多语言错误信息
            errorMessage = res.info[currentLang];
          } else if (res.info) {
            // 使用后端返回的通用错误信息
            errorMessage = res.info;
          } else {
            // 使用默认错误信息
            errorMessage = this.$t('register.RegisterFailed');
          }
          
          this.$toast({
            background: "#ff4d4f",
            message: errorMessage,
          });
        }
      }).catch((error) => {
        // 处理真正的网络错误或其他异常
        console.error('注册网络请求失败:', error);
        this.$toast({
          background: "#ff4d4f",
          message: '网络连接失败，请检查网络后重试',
        });
      });
    },
    userAgreement() {
      this.agreement = true;
    },
    agreementHider() {
      this.agreement = false;
    },
    privacyStatement() {
      this.statement = true;
    },
    privacyStatementHide() {
      this.statement = false;
    },
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* 顶部注册标题 */
.register_header {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;

  .big_tit {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
}

/* 主要内容区域 */
.main_content {
  flex: 1;
  padding: 20px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 蚂蚁集团logo */
.ant_group_logo {
  margin-bottom: 40px;
  text-align: center;
  width: 252px;
  height: 160px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;

  img {
    width: 100%;
    height: 100%;
  }
}

/* 注册表单 */
.register_form {
  width: 100%;
  max-width: 300px;
  margin-bottom: 40px;
}

.input_group {
  margin-bottom: 20px;
}

.form_input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  background: #f5f5f5;
  box-sizing: border-box;
  color: #333;

  &:focus {
    outline: none;
    background: #f0f0f0;
  }

  &::placeholder {
    color: #999;
  }
}

.submit_btn {
  width: 100%;
  height: 48px;
  background: #1890ff;
  color: #ffffff;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  transition: background-color 0.3s;

  &:hover {
    background: #40a9ff;
  }

  &.disabled {
    background: #d9d9d9;
    cursor: not-allowed;
  }
}

.login_link {
  text-align: center;

  a {
    color: #1890ff;
    text-decoration: none;
    font-size: 14px;
  }
}

.login_bottom {
  width: 368px;
  height: 272px;
  margin: 0 auto;
  margin-top: 0px;

  img {
    width: 100%;
    height: 100%;
  }
}

/* 底部导航栏样式已移至FooterTab组件 */

/* 隐藏原有样式 */
/* .login_bg {
		width: 100%;
		height: 178px;
		background: url(../images/login/login_bg.png) no-repeat center center;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.basic_wrap .form {
		margin: -115px auto 0 auto;
		width: 90%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 13px;
		padding: 31px 24px 31px 24px;
	}

	.cut_login {
		width: 207px;
		line-height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		text-align: center;
		margin: 0 auto;

		a {
			width: 50%;
			padding-bottom: 10px;
			color: #ceced0;
			position: relative;

			.line {
				width: 100%;
				height: 1px;
				position: absolute;
				left: 0;
				bottom: 0;
				background-color: #f2f2f2;
			}
		}

		a.cur {
			color: #f12211;

			.line {
				height: 2px;
				background-image: linear-gradient(to right, #f12211, #f18a11);
			}
		}
	}

	.block {
		width: 100%;
		height: 100%;
		font-size: 15px;
		justify-content: center;
		background-color: #fff;
		border-radius: 5px;

		.block-title {
			display: block;
			font-weight: bolder;
			line-height: 39px;
			height: 39px;
			text-align: center;
		}

		.p_agr {
			font-size: 12px;
			line-height: 20px;
			padding: 0px 10px;
			height: 388px;
			-webkit-overflow-scrolling: touch;
			overflow-y: scroll;
		}

		.div_qd {
			width: 60px;
			height: 25px;

			span {
				width: 60px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				justify-content: center;
				background: #fb661e;
				border-radius: 10px;
				padding: 1px 5px;
				color: #fff;
			}

			margin: 10px auto;
		}
	}

	.item {
		height: 58px;
		border-bottom: 1px solid #f0f1f3;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		padding-bottom: 4px;

		.icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 28px;
			height: 24px;

			.people {
				width: 23px;
				height: 20px;
			}

			img {
				width: 100%;
				height: 100%;
			}
		}

		input {
			height: 20px;
			margin-left: 7px;
			flex: 1;
			margin-bottom: 3px;
		}
	}

	.get_captcha {
		width: 88px;
		height: 34px;
		background: linear-gradient(90deg,
				rgba(228, 57, 46, 1) 0%,
				rgba(254, 76, 22, 1) 100%);
		border-radius: 4px;
		text-align: center;
		line-height: 34px;
		font-size: 14px;
		color: #ffffff;
	}

	.protocol {
		font-size: 12px;
		line-height: 17px;
		margin-top: 20px;
		color: #999999;

		a {
			color: #3d96ff;
		}
	}

	.basic_btn {
		margin: 36px auto 0 auto;
	} */
</style>
